const COURSES = 'kurse';
const DIGITALIZATION = 'digitalisierung';
const FIRMENSCHULUNGEN = 'firmenschulungen';

export const Url = Object.freeze({
	BOOKING: 'buchung',
	BOOKING_SUCCESS: 'buchung/erfolgreich',
	CART: 'warenkorb',
	CONTACT: 'kontakt',
	COURSES,
	DATA_PRIVACY: 'datenschutzerklaerung',
	DIGITALIZATION,
	FIRMENSCHULUNGEN: `${COURSES}/${FIRMENSCHULUNGEN}`,
	BLOG: 'blog',
	AGB: 'agbs',
	IMPRINT: 'impressum',
	REFERENCES: 'referenzen',
	ABOUT: 'ueber-uns',
});

export const BreadCrumbItem = Object.freeze({
	HOME: {
		title: 'Home',
		to: '/',
	},
	COURSES: {
		title: 'Kurse',
		to: `/${Url.COURSES}/`,
	},
	DIGITALIZATION: {
		title: 'Digitalisierung',
		to: `/${Url.DIGITALIZATION}/`,
	},
	FIRMENSCHULUNGEN: {
		title: 'Firmenschulungen',
		// without the COURSES prefix as this is seperate entry in a breadcrumb
		to: `/${Url.FIRMENSCHULUNGEN}`,
	},
	BLOG: {
		title: 'Blog',
		to: `/${Url.BLOG}/`,
	},
	CONTACT: {
		title: 'Kontakt',
		to: `/${Url.CONTACT}/`,
	},
	REFERENCES: {
		title: 'Referenzen',
		to: `/${Url.REFERENCES}/`,
	},
	ABOUT: {
		title: 'Über uns',
		to: `/${Url.ABOUT}/`,
	},
});
